import React, { useCallback, useEffect } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { PageTreeStateUpdater } from '@confluence/page-tree-refresh-state-container';

export type ForceFetchPageIds = (pageIds: Array<number | string>) => void;

type PageTreeForceFetchSubscriberProps = {
	onForceFetchPageIdsChange: (forceFetchPageIds: ForceFetchPageIds | null) => void;
};

type PageTreeForceFetchRegistrationProps = PageTreeForceFetchSubscriberProps & {
	pageTreeStateUpdater: PageTreeStateUpdater;
};

const PageTreeForceFetchRegistration = ({
	pageTreeStateUpdater,
	onForceFetchPageIdsChange,
}: PageTreeForceFetchRegistrationProps) => {
	const forceFetchPageIds = useCallback<ForceFetchPageIds>(
		(pageIds) => {
			const uniquePageIds = new Set<string>();
			pageIds.forEach((pageId) => {
				const normalizedPageId = String(pageId);
				if (normalizedPageId) {
					uniquePageIds.add(normalizedPageId);
				}
			});
			uniquePageIds.forEach((pageId) => {
				pageTreeStateUpdater.setForceFetchPageId(pageId);
			});
		},
		[pageTreeStateUpdater],
	);

	useEffect(() => {
		onForceFetchPageIdsChange(forceFetchPageIds);

		return () => onForceFetchPageIdsChange(null);
	}, [forceFetchPageIds, onForceFetchPageIdsChange]);

	return null;
};

export const PageTreeForceFetchSubscriber = ({
	onForceFetchPageIdsChange,
}: PageTreeForceFetchSubscriberProps) => (
	<Subscribe to={[PageTreeStateUpdater]}>
		{(pageTreeStateUpdater: PageTreeStateUpdater) => (
			<PageTreeForceFetchRegistration
				pageTreeStateUpdater={pageTreeStateUpdater}
				onForceFetchPageIdsChange={onForceFetchPageIdsChange}
			/>
		)}
	</Subscribe>
);
